import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, Toggle } from "material-ui"
import strings from "../../localization/strings"
import { IDateRange, IPayrollExportHierarchyData, IPayrollPayCalendar } from "../../models"
import moment from "moment"

interface IProps {
    selectedPayCalendar: IPayrollPayCalendar
    payrollDates: IDateRange
    exportHierarchyData: IPayrollExportHierarchyData[]
    handleClose(): void
    handleExport(exportAgain: boolean): void
}
interface IState {
    exportAgain: boolean
}

export default class ExportPayrollTimeConfirmDialog extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            exportAgain: false
        }
        autobind(this)
    }

    render() {
        const exportedEmployeeExist = this.props.exportHierarchyData.find(i => i.ExportedEmployeeCount > 0)
        return (
            <Dialog
                open
                modal
                autoScrollBodyContent
                title={
                    <div>
                        <div>{strings.Export_Payroll}</div>
                        <div style={{ fontSize: 16 }}>
                            {`${this.props.selectedPayCalendar.PayCalendarLabel} | ${moment(this.props.payrollDates.StartDate).format("MMMM Do YYYY")} - ${moment(this.props.payrollDates.EndDate).utc(true).format("MMMM Do YYYY")}`}
                        </div>
                    </div>
                }
                actions={[
                    <FlatButton label={strings.CANCEL} style={{ float: "left" }} primary={false} onClick={this.props.handleClose} />,
                    <FlatButton label={strings.Confirm_Export} primary keyboardFocused onClick={() => this.props.handleExport(this.state.exportAgain)} />
                ]}
            >
                <div>
                    <div>
                        {strings.You_have_selected_payroll_hierarchies_for_export_This_export_contains_the_following}
                    </div>
                    <div style={{ marginTop: 20 }}>
                        {this.props.exportHierarchyData.map((hierarchy, index) =>
                            <div key={index} style={{ marginLeft: 20 }}>
                                <div>{`- ${hierarchy.HierarchyName}`}</div>
                                <div style={{ marginLeft: 20 }}>
                                    <div>{`- ${hierarchy.EmployeeCount} ${strings.Employees}`}</div>
                                    {hierarchy.UnapprovedEmployeeCount > 0 &&
                                        <div style={{ marginLeft: 20 }}>{`- ${hierarchy.UnapprovedEmployeeCount} ${strings.Unapproved_employees}`}</div>
                                    }
                                    {hierarchy.ExportedEmployeeCount > 0 &&
                                        <div style={{ marginLeft: 20 }}>{`- ${hierarchy.ExportedEmployeeCount} ${strings.Exported_employees}`}</div>
                                    }
                                    <div>{`- ${hierarchy.TotalHours} ${strings.TotalHours}`}</div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div style={{ marginTop: 20 }}>
                        {strings.Upon_confirmation_employee_time_will_be_exported}
                    </div>
                    {exportedEmployeeExist &&
                        <Toggle
                            style={{ marginTop: 20 }}
                            toggled={this.state.exportAgain}
                            onToggle={(e, v) => {
                                this.setState({ exportAgain: v })
                            }}
                            labelPosition="right"
                            label={strings.Include_employees_that_have_already_been_exported}
                        />
                    }
                </div>
            </Dialog>
        )
    }
}
